export default "__VITE_ASSET__CWyji3CI__"